module.exports = __webpack_public_path__ + "img/logs_fabs.ba352ebe.png";